module.exports = __webpack_public_path__ + "img/banner4.89a5016f.png";